import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useDate } from "@/hooks/use-date/useDate";
import { Icon } from "@/components/icons/Icon";
import { PHASES_LIST } from "@/assets/constants/selectsLists";

import type { FC } from "react";

interface CurrentPhaseMobileProps {
  currentPhase: number | null;
  tasks: number;
  completed: number;
  phaseStartDate: string;
}

const CurrentPhaseMobile: FC<CurrentPhaseMobileProps> = ({
  currentPhase,
  tasks,
  completed,
  phaseStartDate,
}) => {
  const translate = useTranslate();
  const { formatDate, getDaysSince } = useDate();

  const getPhaseName = () => {
    return PHASES_LIST.find((item) => item.id === currentPhase)?.name || "";
  };

  return (
    <div className="w-full flex px-4 gap-2 text-sm py-2 bg-ib-gray-lightest-2 border-b border-b-ib-gray-lightest">
      <div className="flex flex-col gap-2">
        <div className="flex gap-1 items-center">
          <Icon name="gear" className="size-5 text-ib-gray-dark-2 mr-1" />
          <span className="text-ib-gray-main mr-1">
            {translate("inProgress")}:
          </span>
        </div>
        <span className="ib-gray-darkest font-ib-bold text-nowrap">
          {translate(getPhaseName())}
        </span>
      </div>
      <div className="flex border" />
      <div className="flex-1 flex flex-col gap-2">
        <p className="text-ib-gray-main flex gap-1">
          <span>{translate("completed")}:</span>
          <span className="font-ib-bold text-ib-gray-darkest">
            {completed} {translate("of")} {tasks}{" "}
            {translate("tasks")?.toLowerCase()}
          </span>
        </p>
        <p className="text-ib-gray-main flex w-full justify-between ">
          <span>
            {translate("stageStart")}: {formatDate(phaseStartDate)}
          </span>
          <span className=" font-ib-bold text-ib-gray-darkest ">
            {getDaysSince(phaseStartDate)}
          </span>
        </p>
      </div>
    </div>
  );
};

export default CurrentPhaseMobile;
